package org.matthewo.components

import emotion.react.css
import js.objects.buildReadonlyRecord
import org.matthewo.YEAR_PARAM
import org.matthewo.styles.BACKGROUND_COLOR
import org.matthewo.styles.TITLE_FONT_COLOR
import react.FC
import react.Props
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.select
import tanstack.react.router.useLocation
import tanstack.react.router.useMatchRoute
import tanstack.react.router.useNavigate
import web.cssom.Globals
import web.cssom.None
import web.cssom.em

external interface YearSelectorProps : Props {
    var years: List<Int>?
    var current: Int?
}

val YearSelector = FC<YearSelectorProps> { props ->
    val location = useLocation()
    val navigate = useNavigate()
    val match = useMatchRoute()

    val current = props.current ?: location.pathname.split("/").firstNotNullOfOrNull { it.toIntOrNull() }
    val years = props.years ?: if (null == current) [] else [current]

    select {
        css {
            height = 1.2.em
            color = TITLE_FONT_COLOR
            backgroundColor = BACKGROUND_COLOR
            fontFamily = Globals.inherit
            fontSize = 1.em
            border = None.none
        }

        value = current ?: ""
        years.forEach { year ->
            option {
                +year.toString()
            }
        }
        onChange = { event ->
            navigate {
                params = buildReadonlyRecord {
                    this[YEAR_PARAM] = event.target.value
                }
            }
        }
    }
}
